import { css, html } from "lit"
import "@luminecence/composants/BoutonIcone"
import "@luminecence/composants/ChampAutocompletion"
import "@luminecence/composants/BoutonsSegmente"
import "@luminecence/composants/BoutonSegmente"
import "@luminecence/composants/CaseACocher"
import PopupBase from "@luminecence/composants/PopupBase"

export default class PopupAjoutMonPokemonAEchange extends PopupBase {
  static properties = {
    erreur: { type: String },
    nomPokemon: { type: String },
    shiny: { type: Boolean },
    dynamax: { type: Boolean },
    gigamax: { type: Boolean },
    fond: { type: Boolean },
    commentaire: { type: String },
    sexe: { type: String },
  }

  static styles = [
    PopupBase.styles,
    css`
      :host {
        background-color: var(--couleur-200);
        max-width: 95vw;
        max-height: 95vh;
        view-transition-name: web-component-popup;
      }

      :host .conteneur {
        width: 100%;
        box-sizing: border-box;
      }

      :host .conteneur .formulaire {
        gap: 2rem;
        padding: 0.5rem;
      }

      :host .conteneur .specificites {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
      }

      :host .conteneur .zone-caracteristiques {
        display: flex;
        flex-direction: column;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto 1fr auto;
        justify-items: start;
        gap: 2rem;

        section {
          display: flex;
          gap: 1.6rem;
        }
      }

      :host .conteneur input[type="checkbox"] {
        width: 2rem;
        height: 2rem;
      }
    `,
  ]

  promesse

  constructor() {
    super()
    this.nomPokemon = ""
    this.shiny = false
    this.dynamax = false
    this.gigamax = false
    this.fond = false
    this.erreur = ""
    this.commentaire = ""
    this.sexe = ""
  }

  render() {
    return html`
        <div class="conteneur">
            <h1>Ajouter un pokémon</h1>
            ${this.genererTemplateErreur()}
            <div class="formulaire">
                <div class="libelle-champ"><label>nom</label>${this.genererChampAutocompletion()}</div>
                <div class="libelle-champ"><label>note</label><textarea id="commentaire" placeholder="commenter..." @change=${this.changerCommentaire}>${this.commentaire}</textarea></div>
                <div class="specificites">
                    <div class="zone-caracteristiques">
                      <section>
                        <p-case-a-cocher id="shiny" .coche=${this.shiny} .libelle=${"shiny"} .valeur=${"shiny"} .icone=${"shiny"}></p-case-a-cocher>
                        <p-case-a-cocher id="fond" .coche=${this.fond} .libelle=${"fond"} .valeur=${"fond"}></p-case-a-cocher>
                      </section>
                      <p-boutons-segmente id="zone-dynamax-gigamax">
                        <p-bouton-segmente ?selectionne=${this.dynamax} .texte=${"dynamax"} .valeur=${"dynamax"}></p-bouton-segmente>
                        <p-bouton-segmente ?selectionne=${this.gigamax} .texte=${"gigamax"} .valeur=${"gigamax"}></p-bouton-segmente>
                      </p-boutons-segmente>
                    </div>
                    <p-boutons-segmente id="zone-sexe">
                      <p-bouton-segmente texte="femelle" ?selectionne=${this.sexe === "femelle"} .valeur=${"femelle"}></p-bouton-segmente>
                      <p-bouton-segmente texte="male" ?selectionne=${this.sexe === "male"} .valeur=${"male"}></p-bouton-segmente>
                    </p-boutons-segmente>
                </div>
            </div>
        </div>
          ${this.renderBoutons()}
        `
  }

  genererChampAutocompletion() {
    const valeursPossibles = window.listePokemons.map((pokemon) => pokemon?.name?.fr).slice(1)
    return html`<p-champ-autocompletion id="nom-pokemon" .valeur=${this.nomPokemon} .valeursPossible=${valeursPossibles} .placeholder=${"nom du pokémon"} @evenementChangementValeur=${this.changerNom}></p-champ-autocompletion>`
  }

  genererTemplateErreur() {
    return this.erreur ? html`<span class="erreur">${this.erreur}</span>` : ""
  }

  changerNom(event) {
    this.nomPokemon = event.target.valeur
  }

  changerCommentaire(event) {
    this.commentaire = event.target.value
  }

  formulaireValide() {
    if (this.nomPokemon === "") {
      this.erreur = "Le nom du pokémon est obligatoire"
      return false
    }

    return true
  }

  valider() {
    if (this.formulaireValide()) {
      const shiny = this.shadowRoot.querySelector("#shiny"),
        dynamaxOuGigamax = this.shadowRoot.querySelector("#zone-dynamax-gigamax").valeur,
        fond = this.shadowRoot.querySelector("#fond"),
        sexe = this.shadowRoot.querySelector("#zone-sexe").valeur

      this.dispatchEvent(
        new CustomEvent("valider", {
          bubbles: true,
          composed: true,
          detail: {
            nom: this.nomPokemon,
            shiny: shiny.coche,
            dynamax: dynamaxOuGigamax === "dynamax",
            gigamax: dynamaxOuGigamax === "gigamax",
            fond: fond.coche,
            commentaire: this.commentaire,
            sexe: sexe === "femelle" ? "femelle" : sexe === "male" ? "male" : "",
          },
        }),
      )
      this.fermerPopup()
    }
  }

  annuler() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    )
    this.fermerPopup()
  }
}

customElements.define("p-popup-ajout-mon-pokemon-a-echange", PopupAjoutMonPokemonAEchange)
